export default __webpack_public_path__ + "assets/people/level.f6ed8bdb4d00509552b1858e46b3e356.svg";